/// <reference path="./bottle.d.ts" />

module PoskiQ {
    "use strict";

    export class ServiceContainer {
        public static Instance: ServiceContainer;

        private bottle: Bottle;

        public constructor() {
            this.bottle = new Bottle();
        }

        public registerFactory<T>(name: string, factory: (container: ServiceContainer) => T): void {
            this.bottle.factory(name, (c) => factory(this));
        }

        public get<T>(name: string): T {
            return this.bottle.container[name];
        }
    }

    ServiceContainer.Instance = new PoskiQ.ServiceContainer();
}
